import React,{ useContext } from "react";
import { db, projectStorage } from "../firebase/firebaseConfig";
import { AuthContext } from '../context/AuthContext';
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Modal from "@material-ui/core/Modal";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import "../styles/RenameDeleteAlbum.css";

const RenameAlbum = ({ albumId, setAlbumName, sortedArray, albumName, setLoading }) => {
  let history = useHistory();
  const { currentUser } = useContext(AuthContext);
  const collectionRef = db.collection(currentUser.email).doc(currentUser.uid).collection("albums");
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const renameHandler = (e) => {
    const newAlbumName = prompt("What do you want the new name to be?");
    if (newAlbumName === null) {
      return;
    }
    if (newAlbumName) {
      collectionRef
        .doc(albumId)
        .get()
        .then((doc) => {
          console.log(doc);
          console.log(doc.data());
          const data = doc.data();
          data.albumName = newAlbumName.trim();
          console.log(data);
          db.collection("albums")
            .doc(albumId)
            .update({
              ...data,
            });
        });
      setAlbumName(newAlbumName);
    } else {
      alert("please enter valid input!");
    }
  };

  const deleteImageFromStorage = (selectedImage) => {
    const storageImageUrlRef = selectedImage.url;
    projectStorage.refFromURL(storageImageUrlRef).delete();
  };

  const deleteAlbumHandler = () => {
    let imageArray = sortedArray;
    if(imageArray){
      collectionRef
      .doc(albumId)
      .delete()
      .then(() => {
        imageArray.forEach((img) => {
          deleteImageFromStorage(img);
        });
      })
      .catch((error) => console.log(error));
    }
  
    history.push("/");
  };

  const backHandler = () => {
    setLoading(false);
    history.push("/");
  }

  return (
    <div>
      <div className="renameDeleteAlbum__parent">
      <Button
          variant="contained"
          style={{ backgroundColor: "#fb9300", color: "", margin:"1rem" }}
          onClick={backHandler}
        >
          back
        </Button>
        <Button
          variant="contained"
          style={{ backgroundColor: "#ff4a4a", color: "white" }}
          onClick={handleClickOpen}
        >
          Delete Album
        </Button>
        <Dialog
          fullScreen={fullScreen}
          open={open}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">
            {"Are you sure you want to delete the album?"}
          </DialogTitle>
          <DialogActions>
            <Button autoFocus onClick={deleteAlbumHandler} color="primary">
              Yes
            </Button>
            <Button onClick={handleClose} color="primary" autoFocus>
              No
            </Button>
          </DialogActions>
        </Dialog>
        <Button
          variant="contained"
          style={{ backgroundColor: "#fb9300", color: "", margin:"1rem" }}
          onClick={renameHandler}
        >
          rename
        </Button>
        
      </div>
    </div>
  );
};

export default RenameAlbum;
